import React from 'react'
import { Button, Pane, Chevron, majorScale } from '@segment/react-ui-library'
import { Link as ReactRouterLink } from 'react-router'
import TabBarItem from './presentational/TabBarItem'
import UserCard from './presentational/UserCard'
import ActivitiesCard from './presentational/ActivitiesCard'
import Row from './presentational/Row'
import Card from './presentational/Card'
import SkeletonText from './presentational/SkeletonText'
import CardHeader from './presentational/CardHeader'
import SummaryIcon from './icons/summary'
import EventHistoryIcon from './icons/event-history'
import UserInfoIcon from './icons/user-info'

const flexCenter = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}

const CustomersProfile = props => {
  const { user } = props

  return (
    <div>
      <Pane display='flex' white borderBottom overflow='hidden'>
        <Pane width='25%' padding={majorScale(2)}>
          <Button size='small' to={`/${props.workspaceSlug}/customers/profiles`} is={ReactRouterLink}>
            <Chevron size='9px' aim='left' marginTop='-1px' marginLeft='-6px' marginRight='6px' />
            Back to Profiles
          </Button>
        </Pane>
        <Pane flexAuto textAlign='center' {...flexCenter}>
          <Pane white {...flexCenter}>
            <TabBarItem icon={<SummaryIcon />} active={props.path === 'overview'}
              to={`/${props.workspaceSlug}/customers/profiles/${user.segmentId}/overview`}>
              Overview
            </TabBarItem>
            <TabBarItem icon={<EventHistoryIcon />} active={props.path === 'events'}
              to={`/${props.workspaceSlug}/customers/profiles/${user.segmentId}/events`}>
              Event History
            </TabBarItem>
            <TabBarItem icon={<UserInfoIcon />} active={props.path === 'traits'}
              to={`/${props.workspaceSlug}/customers/profiles/${user.segmentId}/traits`}>
              Properties
            </TabBarItem>
          </Pane>
        </Pane>
        <Pane width='25%' textAlign='right' />
      </Pane>
      <Pane maxWidth='100%' width={740} marginTop={majorScale(3)} marginBottom={majorScale(10)} marginRight='auto' marginLeft='auto'>
        <Pane tint clearfix>
          {props.isRequesting ? <Skeleton /> : props.children}
        </Pane>
      </Pane>
    </div>
  )
}

const Skeleton = props => {
  return (
    <Pane>
      <UserCard skeleton>
        <Pane display='flex' paddingX='24px' paddingY='12px'>
          <SkeletonText />
        </Pane>
      </UserCard>
      <ActivitiesCard skeleton events={[]} />
      <Card>
        <CardHeader title='Recent Events' alignItems='center'>
          <Button size='small'>All Events</Button>
        </CardHeader>
        <Row skeleton />
        <Row skeleton />
        <Row skeleton />
        <Row skeleton />
        <Row skeleton />
        <Row skeleton />
      </Card>
    </Pane>
  )
}

export default CustomersProfile



// WEBPACK FOOTER //
// ./components/Customers/CustomersProfile.js